import React from 'react';
import {Card, Dialog} from "@mui/material";

export default function FormModal(props) {

    const open = props.open;
    const titleText = props.titleText !== undefined ? props.titleText : "No Title Provided";
    const content = props.content !== undefined ? props.content : <div>No Content</div>;

    const width = props.width !== undefined ? props.width : 600;
    const height = props.height !== undefined ? props.height : 300;

    const handleClose = () => {
        if (props.close !== undefined) {
            props.close();
        }
    }

    return (
        <React.Fragment>
            <Dialog
                open={open}
                onClose={handleClose}
            >
                <Card style={{
                    width: width+"px",
                    maxWidth: "100%",
                    height: height+"px"
                }}>
                    <div className={"info-status-title"}>
                        {titleText}
                    </div>
                    {content}
                </Card>
            </Dialog>
        </React.Fragment>
    )

}